var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPassword(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.743,
    height: 21.004,
    viewBox: "0 0 17.743 21.004",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3755",
    "data-name": "Path 3755",
    d: "M1122.132,396.641v1.6a4.348,4.348,0,0,1,3.11,4.132v5.153a4.406,4.406,0,0,1-4.457,4.357h-8.829a4.406,4.406,0,0,1-4.457-4.357v-5.153a4.36,4.36,0,0,1,3.11-4.132v-1.6a5.762,5.762,0,0,1,11.524,0Zm-5.751-3.817a3.861,3.861,0,0,1,3.893,3.817v1.376h-7.807v-1.4a3.861,3.861,0,0,1,3.914-3.8Zm.918,13.271a.929.929,0,1,1-1.858,0v-2.3a.929.929,0,1,1,1.858,0Z",
    transform: "translate(-1107.5 -390.879)",
    fill: "#797979",
    fillRule: "evenodd"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/password.d4bf7ba786cbb6a3c27348b8d85d2f01.svg";
export { ForwardRef as ReactComponent };